export const bytesToGb = (bytes: number) => bytes / (1024 * 1024 * 1024)
export const bytesToMb = (bytes: number) => bytes / (1024 * 1024)
export const bytesToKb = (bytes: number) => bytes / 1024
